(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(marquee) {
      var track = marquee.querySelector('[data-aaf-track]');
      if (!track) return;
      var count = parseInt(marquee.getAttribute('data-count') || '0', 10);
      var speed = parseFloat(marquee.getAttribute('data-speed') || '40') || 40; // px per second
      if (count < 1) return;

      // Clear any clones we added on a previous run
      var old = track.querySelectorAll('[data-aaf-clone]');
      for (var j = 0; j < old.length; j++) old[j].remove();

      var children = track.children;
      if (children.length < count + 1) return; // need originals + at least one duplicate

      // Width of exactly one copy (incl. the gap that follows it)
      var oneCopy = children[count].offsetLeft;
      if (!oneCopy || oneCopy < 1) return;

      // Add extra copies until the track comfortably fills the viewport + one copy,
      // so the seamless loop never reveals empty space.
      var containerW = marquee.clientWidth;
      var guard = 0;
      while (track.scrollWidth < containerW + oneCopy && guard < 30) {
        for (var i = 0; i < count; i++) {
          var clone = children[i].cloneNode(true);
          clone.setAttribute('data-aaf-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          track.appendChild(clone);
        }
        guard++;
      }

      var duration = oneCopy / speed; // seconds for one copy to pass = constant px/sec
      track.style.setProperty('--aaf-shift', oneCopy + 'px');
      track.style.setProperty('--aaf-duration', duration + 's');
    }

    function setupAll() {
      document.querySelectorAll('[data-aaf-marquee]').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupAll);
    } else {
      setupAll();
    }

    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(setupAll, 200);
    });
    document.addEventListener('shopify:section:load', setupAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
